// 脚本生成----
import getBase64Image from '../getBase'
import Vue from 'vue'
let ucDetailDefault = {}
//let img = new Image()
//img.src = require('../../assets/icons/uc-detail-default.png')
//img.onload = function () {
  Vue.set(ucDetailDefault, 'src', require('../../assets/icons/uc-detail-default.png'))
//}
export default ucDetailDefault
